import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconLockSvg } from "./IconLockSvg.mjs";
const IconLock = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconLockSvg, ...iconProps });
};
export {
  IconLock
};
